export const GET_REPORTS_MANAGEMENT = "GET_REPORTS_MANAGEMENT"
export const GET_REPORTS_MANAGEMENT_SUCCESS = "GET_REPORTS_MANAGEMENT_SUCCESS"

export const API_ERROR = "REPORTS_MANAGEMENT_API_ERROR"
